import styled from 'styled-components';

export const GrowWrapper = styled.div`
  transition: all 0.3s ease-out;
  &:hover {
    transform: scale(1.1);
  }
`;